import React from "react";
import LoadingIndicator from "@/components/LoadingIndicator/LoadingIndicator";
const ModelStatus = ({ status }) => {
    if (status === "ERROR" || status === "ENABLED" || status === "FAILED") {
        return React.createElement("div", null, status === "ENABLED" ? "Ready" : "Failed");
    }
    if (status === "SUCCEEDED") {
        return React.createElement("div", null, "Completed");
    }
    if (status === "PENDING" || status === "RUNNING") {
        return (React.createElement("div", { style: { display: "flex", alignItems: "center" } },
            React.createElement(LoadingIndicator, { style: { marginLeft: "-14px", scale: "0.5", marginRight: "0px" } }),
            "In Progress"));
    }
    return React.createElement("div", null, status.charAt(0).toUpperCase() + status.substring(1).toLowerCase());
};
export default ModelStatus;
